import axios from 'axios'
import {
    GET_TEMPLATE_CONTENT_FAIL,
    GET_TEMPLATE_CONTENT_REQUEST,
    GET_TEMPLATE_CONTENT_SUCCESS,
    GET_USER_TEMPLATES_FAIL,
    GET_USER_TEMPLATES_REQUEST,
    GET_USER_TEMPLATES_SUCCESS,
    UPDATE_TEMPLATE_FAIL,
    UPDATE_TEMPLATE_REQUEST,
    UPDATE_TEMPLATE_SUCCESS,
    DELETE_TEMPLATE_REQUEST,
    DELETE_TEMPLATE_SUCCESS,
    DELETE_TEMPLATE_FAIL,
    CREATE_TEMPLATE_REQUEST,
    CREATE_TEMPLATE_SUCCESS,
    CREATE_TEMPLATE_FAIL
} from '../constants/templateConstants';

export const getUserTemplates = (user_id) => async(dispatch) => {
    dispatch({
        type: GET_USER_TEMPLATES_REQUEST
    })

    try {
        const { data } = await axios.get(process.env.REACT_APP_GOLANGAPI + '/api/template/user/' + user_id)

        dispatch({
            type: GET_USER_TEMPLATES_SUCCESS,
            payload: data,
        })
    }
    catch(error) {
        dispatch({
            type: GET_USER_TEMPLATES_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}

export const getTemplateContent = (template_id) => async(dispatch) => {
    dispatch({ type: GET_TEMPLATE_CONTENT_REQUEST })

    try {
        const { data } = await axios.get(process.env.REACT_APP_GOLANGAPI + '/api/template/' + template_id)
        
        dispatch({
            type: GET_TEMPLATE_CONTENT_SUCCESS,
            payload: data,
        })
    }
    catch(error) {
        dispatch({
            type: GET_TEMPLATE_CONTENT_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}

export const createTemplate = (name, userId, reportTypeId) => async(dispatch) => {
    dispatch({type: CREATE_TEMPLATE_REQUEST })

    try {

        const config = {
            headers:{
                'Content-type': 'application/json',
            }
        }

        const { data } = await axios.post(process.env.REACT_APP_GOLANGAPI + '/api/template',
            {
                userId: userId,
                reportTypeId: reportTypeId,
                name: name
            },
            config
        )
        
        dispatch({
            type: CREATE_TEMPLATE_SUCCESS,
            payload: data,
        })

        dispatch(getUserTemplates(userId))
    }
    catch(error) {
        dispatch({
            type: CREATE_TEMPLATE_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}

export const updateTemplate = (template_id, update) => async(dispatch) => {
    dispatch({type: UPDATE_TEMPLATE_REQUEST })

    try {

        const config = {
            headers:{
                'Content-type': 'application/json',
            }
        }

        const { data } = await axios.put(process.env.REACT_APP_GOLANGAPI + '/api/template/' + template_id,
            {
                userId: update.userId,
                templateId: template_id,
                reportTypeId: update.reportTypeId,
                name: update.name,
                content: update.content,
            },
            config
        )
        
        dispatch({
            type: UPDATE_TEMPLATE_SUCCESS,
            payload: data,
        })
   }
    catch(error) {
        dispatch({
            type: UPDATE_TEMPLATE_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}

export const deleteTemplate = (template_id, user_id) => async(dispatch) => {
    dispatch({type: DELETE_TEMPLATE_REQUEST })

    try {

        const config = {
            headers:{
                'Content-type': 'application/json',
            }
        }

        const { data } = await axios.delete(process.env.REACT_APP_GOLANGAPI + '/api/template/' + template_id,
            {
                userId: user_id,
                templateId: template_id,
            },
            config
        )
        
        dispatch({
            type: DELETE_TEMPLATE_SUCCESS,
            payload: data,
        })

        dispatch(getUserTemplates(user_id))
    }
    catch(error) {
        dispatch({
            type: DELETE_TEMPLATE_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}